import { useState, useEffect, useContext } from "react";
import { LanguageContext } from "../../contexts/LanguageProvider";

type CaptchaProps = {
  onValid: (valid: boolean) => void;
};

export const Captcha = ({ onValid }: CaptchaProps) => {
  const [question, setQuestion] = useState("");
  const [correctAnswer, setCorrectAnswer] = useState<number>(0);
  const [input, setInput] = useState("");
  const { t } = useContext(LanguageContext);
  useEffect(() => {
    const a = Math.floor(Math.random() * 10) + 1;
    const b = Math.floor(Math.random() * 10) + 1;
    setQuestion(`${a} + ${b} = ?`);
    setCorrectAnswer(a + b);
  }, []);

  useEffect(() => {
    const isCorrect = parseInt(input) === correctAnswer;
    onValid(isCorrect);
  }, [input, correctAnswer, onValid]);

  return (
    <div className="mt-4 flex flex-col gap-2">
      <label className="text-sm">{t("solve-captcha")}</label>
      <div className="flex gap-2 items-center">
        <span className="text-white font-semibold">{question}</span>
        <input
          type="text"
          className="bg-gray-500/20 text-white p-2 rounded-md w-20 text-center focus:outline-none"
          value={input}
          onChange={(e) => setInput(e.target.value)}
        />
      </div>
    </div>
  );
};
